<template>
  <div class="home">
    <img alt="爱驿站 logo" src="/ayz_logo.png">
    <HelloWorld msg="Welcome to 爱驿站"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}
</script>
<style scoped lang="scss">
.home{
    width: 100%;
    img{
        width: 100%;
    }
}
</style>
